import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import { Icon } from '../Icon';
import { getPlanSaveLabel, getPricePerDayLabel } from '../../shared/plan-helpers';
import styles from './SubscriptionCardV9.css';

const cx = classnames.bind(styles);

function SubscriptionCardV9({ className = '', subscriptionData, selectedSubscriptionData, selectSubscription, isExpired = false, name = 'subscription-plan' }) {
    const isActive = subscriptionData.plan === selectedSubscriptionData.plan;
    const oldPrice = subscriptionData.displayOldPrice ?? subscriptionData.price;
    const newPrice = subscriptionData.trial?.price ?? subscriptionData.price;
    const hasOldPrice = !isExpired && oldPrice !== newPrice;
    const saveLabel = hasOldPrice && !subscriptionData.isDiscountBadgeHidden ? getPlanSaveLabel(subscriptionData) : null;

    return (
        <label className={cx('root', className, { active: isActive })}>
            <input
                type='radio'
                name={name}
                value={subscriptionData.plan}
                checked={isActive}
                onChange={() => selectSubscription(subscriptionData)}
                className={styles.input}
            />
            {subscriptionData.isPopular && (
                <div className={styles.popularBanner}>
                    <Icon name='starFilled' className={styles.starIcon} />
                    Most popular
                </div>
            )}
            <div className={styles.content}>
                <div className={styles.planGroup}>
                    <span className={styles.radio}>
                        <span className={styles.radioDot} />
                    </span>
                    <div className={styles.planInfo}>
                        <div className={styles.nameRow}>
                            <p className={styles.name}>{subscriptionData.name}</p>
                            {Boolean(saveLabel) && <span className={styles.saveBadge}>{`SAVE ${saveLabel}`}</span>}
                        </div>
                        <p className={styles.priceRow}>
                            {hasOldPrice && <span className={styles.oldPrice}>{oldPrice}</span>}
                            <span className={styles.newPrice}>{newPrice}</span>
                        </p>
                    </div>
                </div>
                <div className={styles.perDayBox}>
                    <p className={styles.perDayPrice}>{getPricePerDayLabel(subscriptionData)}</p>
                    <p className={styles.perDayCaption}>per day</p>
                </div>
            </div>
        </label>
    );
}

SubscriptionCardV9.propTypes = {
    className: PropTypes.string,
    subscriptionData: PropTypes.object.isRequired,
    selectedSubscriptionData: PropTypes.object.isRequired,
    selectSubscription: PropTypes.func.isRequired,
    isExpired: PropTypes.bool,
    name: PropTypes.string
};

export {
    SubscriptionCardV9
};
